/* 🤖 this file was generated by svg-to-ts */
export const emperorIconBriefcase: {
  name: 'briefcase';
  data: string;
} = {
  name: 'briefcase',
  data: `<svg viewBox="0 0 64 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M56 12H48V8C48 3.625 44.375 0 40 0H24C19.5 0 16 3.625 16 8V12H8C3.5 12 0 15.625 0 20V52C0 56.5 3.5 60 8 60H56C60.375 60 64 56.5 64 52V20C64 15.625 60.375 12 56 12ZM24 6H40C41 6 42 7 42 8V12H22V8C22 7 22.875 6 24 6ZM8 18H56C57 18 58 19 58 20V32H6V20C6 19 6.875 18 8 18ZM56 54H8C6.875 54 6 53.125 6 52V38H24V40C24 42.25 25.75 44 28 44H36C38.125 44 40 42.25 40 40V38H58V52C58 53.125 57 54 56 54Z" fill="currentColor"/></svg>`
};
